import type { OrganizationProfilesResponse } from '@pulsify/shared'
import { api, unwrap } from '~/shared/lib/rpc'

/** The organization's profiles (organizer pages and place profiles) as the dashboard switches them. */
export const profilesApi = {
  async list(businessId: string): Promise<OrganizationProfilesResponse> {
    const res = await api.api.channels.profiles.$get({ query: { businessId } })
    return unwrap<OrganizationProfilesResponse>(res)
  },
}
